"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Location = _interopRequireDefault(require("../../molecules/Location"));

require("./Locations.css");

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Locations = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Locations, _React$Component);

  var _super = _createSuper(Locations);

  function Locations(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Locations);
    _this = _super.call(this, props);
    _this.state = {
      activeItem: 0
    };
    _this.handleItemClick = _this.handleItemClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Locations, [{
    key: "handleItemClick",
    value: function handleItemClick(e, _ref) {
      var index = _ref.index;
      return this.setState({
        activeItem: index
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          addresses = _this$props.addresses,
          color = _this$props.color,
          textAlign = _this$props.textAlign,
          verticalAlign = _this$props.verticalAlign;
      var activeItem = this.state.activeItem;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        stackable: true
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        computer: 5,
        tablet: 6,
        mobile: 16,
        color: color,
        textAlign: textAlign,
        verticalAlign: verticalAlign,
        id: "locations-location-list"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu, {
        fluid: true,
        vertical: true,
        style: {
          height: 'auto'
        }
      }, addresses.map(function (address, index) {
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu.Item, {
          key: address.street,
          index: index,
          active: index === activeItem,
          onClick: _this2.handleItemClick,
          style: index === activeItem ? {
            backgroundColor: '#f0eded'
          } : {
            backgroundColor: 'white'
          }
        }, /*#__PURE__*/_react["default"].createElement("p", null, address.street, /*#__PURE__*/_react["default"].createElement("br", null), "".concat(address.city, ", ").concat(address.state, " ").concat(address.zip)));
      }))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        computer: 11,
        tablet: 10,
        mobile: 14,
        stretched: true,
        color: color,
        id: "locations-location-map"
      }, /*#__PURE__*/_react["default"].createElement(_Location["default"], {
        address: addresses[activeItem],
        showAddress: false,
        showMap: true
      })));
    }
  }]);
  return Locations;
}(_react["default"].Component);

exports["default"] = Locations;
Locations.propTypes = {
  addresses: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    street: _propTypes["default"].string,
    city: _propTypes["default"].string.isRequired,
    state: _propTypes["default"].string.isRequired,
    zip: _propTypes["default"].string.isRequired,
    country: _propTypes["default"].string
  })).isRequired,
  color: _propTypes["default"].string,
  textAlign: _propTypes["default"].oneOf(['left', 'center', 'right']),
  verticalAlign: _propTypes["default"].oneOf(['bottom', 'middle', 'top'])
};
Locations.defaultProps = {
  color: null,
  textAlign: 'left',
  verticalAlign: 'middle'
};
Locations.propOptions = {};
Locations.dataPropsMap = {
  locations: ['business', 'locations']
};